package br.com.texeratx.boardgametimeapp.ui.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.dp
import boardgametimeapp.composeapp.generated.resources.Res
import boardgametimeapp.composeapp.generated.resources.texture_paper
import boardgametimeapp.composeapp.generated.resources.texture_shadow
import br.com.texeratx.boardgametimeapp.core.theme.AppThemeMode
import org.jetbrains.compose.resources.DrawableResource

@Immutable
data class AppThemeTokens(
    val screenBackgroundBrush: Brush,
    val textureOverlayRes: DrawableResource,
    val textureOverlayAlpha: Float,
    val loadingScrimColor: Color,
    val placeholderSurfaceColor: Color,
    val interactiveOutlineColor: Color,
    val sectionCardShape: Shape,
)

internal fun themeTokensFor(mode: AppThemeMode): AppThemeTokens =
    when (mode) {
        AppThemeMode.DEFAULT -> AppThemeTokens(
            screenBackgroundBrush = Brush.verticalGradient(
                listOf(
                    Color(0xFFF6EDDE),
                    Color(0xFFEBDABD),
                    Color(0xFFE2D0AE),
                )
            ),
            textureOverlayRes = Res.drawable.texture_paper,
            textureOverlayAlpha = 0.18f,
            loadingScrimColor = Color(0x22000000),
            placeholderSurfaceColor = Color(0xFFDCC8A8),
            interactiveOutlineColor = Color(0xFFA8875A),
            sectionCardShape = RoundedCornerShape(16.dp),
        )

        AppThemeMode.SHADOW -> AppThemeTokens(
            screenBackgroundBrush = Brush.verticalGradient(
                listOf(
                    Color(0xFF0A0F15),
                    Color(0xFF101824),
                    Color(0xFF162231),
                )
            ),
            textureOverlayRes = Res.drawable.texture_shadow,
            textureOverlayAlpha = 0.18f,
            loadingScrimColor = Color(0x66000000),
            placeholderSurfaceColor = Color(0xFF30435C),
            interactiveOutlineColor = Color(0xFF617C9B),
            sectionCardShape = RoundedCornerShape(16.dp),
        )
    }

internal val LocalAppThemeTokens = staticCompositionLocalOf<AppThemeTokens> {
    error("AppThemeTokens not provided")
}

object AppThemeExtras {
    val tokens: AppThemeTokens
        @Composable get() = LocalAppThemeTokens.current
}
